import { Loader2 } from "lucide-react";
import { Card } from "../ui/Card";

export function TestCompletionScreen() {
  return (
    <div className="mx-auto grid min-h-[calc(100svh-4rem)] w-full max-w-2xl content-center px-4 py-8 sm:px-6">
      <Card className="text-center">
        <Loader2 className="mx-auto animate-spin text-cyan-200" size={34} />
        <h1 className="mt-5 text-3xl font-bold text-white">Ολοκληρώνουμε την αναφορά σου</h1>
        <p className="mt-3 text-slate-300">Σε μεταφέρουμε στη locked προεπισκόπηση του premium report.</p>
      </Card>
    </div>
  );
}
